import { DateTimeDetailValue } from "../../../../components/shared/details-cells/DateTimeDetailValue";
import DetailsCells from "../../../../components/shared/details-cells/DetailsCells";
import ACTION_LOGS_DATA_MODEL from "../../../../utils/constants/actionLogsDataModel";
import COMMON_LOGS_DATA_MODEL from "../../../../utils/constants/commonLogsDataModel";
import { valueOrEmpty } from "../../../../utils/helpers/text";
import ActionLogLinkDetailView from "../../ActionLogLinkDetailView";
import RunStatusLabel from "../../common-for-log-sheet-and-run-logs/RunStatusLabel";
import {
  ApproverUserNameCluster,
  Flex,
  RunLogWrapper,
  CustomDetailsCellStyled,
  MediaTypeCell,
  GxpReadyAllCell,
  SystemStatusAllCell,
  CreatedAtCell,
  CreatedTimeAtCell,
  GxpRelevantCell,
  ConfigurationBaselineAllLogCell
} from "../../common-for-log-sheet-and-run-logs/table-common-meta-info";
import ValueOrFallbackText from "../../common-for-log-sheet-and-run-logs/ValueOrFallbackText";
import { changeDateFormat } from "../../helpers";
import RUN_LOGS_DATA_MODEL from "./../../../../utils/constants/runLogsDataModel";
import { customItem } from "../../log-sheet/log-sheet-table/customItem";
import { APPROVE_ACTION_LOG_FIELD, DESCRIPTION_FIELD } from "../../../../utils/constants/descriptionField";
import { ElnLinkRenderer } from "@digitallab/grid-common-frontend-components";

export const AllLogClusterTableMeta = {
  expandable: true,
  ExpandedComponent: ({ item, infoMeta }) => (
    <Flex>
      <DetailsCells Wrapper={RunLogWrapper} item={item} infoMeta={infoMeta} CellWrapper={CustomDetailsCellStyled} />
    </Flex>
  ),
  expandedComponentProps: {
    infoMeta: {
      fields: [
        {
          label: COMMON_LOGS_DATA_MODEL.createdAtTime.value,
          component: CreatedTimeAtCell
        },
        {
          label: "Run start",
          component: ({ item }) => (
            <DateTimeDetailValue date={changeDateFormat(item?.runStartDate)} time={item.runStartTime} />
          )
        },
        {
          label: RUN_LOGS_DATA_MODEL.runEndDate.value,
          component: ({ item }) => (
            <DateTimeDetailValue date={changeDateFormat(item?.runEndDate)} time={item.runEndTime} />
          )
        },
        {
          label: RUN_LOGS_DATA_MODEL.eLNid.value,
          component: ({ item }) => <ElnLinkRenderer elnExperiment={item.eLNid} />
        },
        {
          label: RUN_LOGS_DATA_MODEL.runStatus.value,
          component: RunStatusLabel
        },
        {
          label: RUN_LOGS_DATA_MODEL.runIdentification.value,
          field: ["runIdentification"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.gxpRelevantRun.value,
          field: ["gxpRelevantRun"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.gxpReady.value,
          component: GxpReadyAllCell
        },
        {
          label: RUN_LOGS_DATA_MODEL.systemStatus.value,
          component: SystemStatusAllCell
        },
        {
          label: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
          component: GxpRelevantCell
        },
        {
          label: COMMON_LOGS_DATA_MODEL.approverUserName.value,
          field: ["approverUserName"]
        },
        {
          label: COMMON_LOGS_DATA_MODEL.operatorUserName.value,
          field: ["operatorUserName"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.samplesProcessed.value,
          field: ["samplesProcessed"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.numberOfRuns.value,
          field: ["numberOfRuns"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.defectId.value,
          field: ["defectId"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.mediaType.value,
          component: MediaTypeCell
        },
        {
          label: RUN_LOGS_DATA_MODEL.tipsUsed.value,
          component: ({ item }) => (
            <ValueOrFallbackText reduxPath={["runLogsForm", "tips"]} item={item.tipsUsed} defaultValue="-" />
          )
        },
        {
          label: RUN_LOGS_DATA_MODEL.assay.value,
          component: ({ item }) => <>{item.assay && item.assay.length > 0 ? item.assay.join(", ") : "-"}</>,
          props: {
            expand: true
          }
        },
        {
          label: RUN_LOGS_DATA_MODEL.gxpRelevantRun.value,
          field: ["gxpRelevantRun"]
        },
        {
          label: COMMON_LOGS_DATA_MODEL.description.value,
          field: ["description"],
          props: {
            expand: true
          }
        }
      ]
    },
    actionInfoMeta: {
      fields: [
        {
          label: COMMON_LOGS_DATA_MODEL.createdAtTime.value,
          component: CreatedTimeAtCell
        },
        {
          label: COMMON_LOGS_DATA_MODEL.operatorUserName.value,
          field: ["operatorUserName"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.ecrNumber.value,
          field: ["ecrNumber"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.actionTime.value,
          component: ({ item }) => <DateTimeDetailValue time={item?.actionTime} />
        },
        DESCRIPTION_FIELD,
        APPROVE_ACTION_LOG_FIELD,
        {
          field: ["externalDocument"],
          lookapVal: "externalDocument",
          props: {
            style: { width: "50%" }
          },
          component: ({ item }) => {
            return <ActionLogLinkDetailView externalDocuments={item?.externalDocument} />;
          }
        },
        {
          label: "Equipment relevant attributes",
          lookapVal: "divider"
        },
        {
          label: ACTION_LOGS_DATA_MODEL.systemStatus.value,
          field: ["systemStatus"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.gxpReady.value,
          field: ["gxpReady"]
        },
        {
          label: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
          component: GxpRelevantCell
        },
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.softwareVerison,
          valueKey: "newValue",
          whiteSpace: false
        }),
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.configurationDetails,
          valueKey: "newValue",
          whiteSpace: true
        }),
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.configurationBaseline,
          valueKey: "newValue",
          whiteSpace: true
        })
      ]
    }
  },
  fields: {
    detailExpander: {
      text: ""
    },
    allLogDate: {
      sortable: true,
      text: "Date",
      component: ({ item }) => changeDateFormat(item?.allLogDate)
    },
    createdAt: {
      sortable: true,
      text: COMMON_LOGS_DATA_MODEL.createdAt.value,
      component: CreatedAtCell
    },
    logType: {
      text: "Type"
    },
    typeSpecificDetails: {
      text: "Type specific details (Action type/Run status)",
      component: ({ item }) => valueOrEmpty(item?.typeSpecificDetails, false, "-")
    },
    gxpReady: {
      text: RUN_LOGS_DATA_MODEL.gxpReady.value,
      component: GxpReadyAllCell
    },
    systemStatus: {
      text: RUN_LOGS_DATA_MODEL.systemStatus.value,
      component: SystemStatusAllCell
    },
    gxpRelevant: {
      text: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
      component: GxpRelevantCell
    },
    configurationBaseline: {
      text: ACTION_LOGS_DATA_MODEL.configurationBaseline.value,
      component: ConfigurationBaselineAllLogCell
    },
    description: {
      text: RUN_LOGS_DATA_MODEL.description.value
    },
    ...ApproverUserNameCluster,
    equipmentModel: {
      text: COMMON_LOGS_DATA_MODEL.equipmentModel.value
    },
    equipmentNickName: {
      text: COMMON_LOGS_DATA_MODEL.equipmentNickName.value
    },
    ecrNumber: {
      text: ACTION_LOGS_DATA_MODEL.ecrNumber.value
    },
    eLNid: {
      text: RUN_LOGS_DATA_MODEL.eLNid.value,
      component: ({ item }) => <ElnLinkRenderer elnExperiment={item.eLNid} />
    },
    runIdentification: {
      text: RUN_LOGS_DATA_MODEL.runIdentification.value
    },
    gxpRelevantRun: {
      text: RUN_LOGS_DATA_MODEL.gxpRelevantRun.value
    },
    samplesProcessed: {
      text: RUN_LOGS_DATA_MODEL.samplesProcessed.value
    },
    numberOfRuns: {
      text: RUN_LOGS_DATA_MODEL.numberOfRuns.value
    },
    defectId: {
      text: RUN_LOGS_DATA_MODEL.defectId.value
    },
    mediaType: {
      text: RUN_LOGS_DATA_MODEL.mediaType.value,
      component: MediaTypeCell
    },
    tipsUsed: {
      text: RUN_LOGS_DATA_MODEL.tipsUsed.value,
      component: ({ item }) => (
        <ValueOrFallbackText reduxPath={["runLogsForm", "tips"]} item={item.tipsUsed} defaultValue="-" />
      )
    },
    operatorUserName: {
      text: COMMON_LOGS_DATA_MODEL.operatorUserName.value
    },
    assay: {
      text: RUN_LOGS_DATA_MODEL.assay.value,
      component: ({ item }) => <span>{item.assay && item.assay.length > 0 ? item.assay.join(", ") : "-"}</span>
    },
    configurationDetails: {
      text: ACTION_LOGS_DATA_MODEL.configurationDetails.value
    },
    softwareVersion: {
      text: ACTION_LOGS_DATA_MODEL.softwareVerison.value
    }
  }
};

export default AllLogClusterTableMeta;
